import React, { useContext, useEffect, useRef, useState } from 'react';
import { Grid, useTheme, useMediaQuery } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useFormContext } from '../Context/Context';
import { useReadOnly } from '../Context/ReadOnlyContext';
import { FinalValuesContext } from '../Context/FinalValuesContext';
import ConvertTitle from './ConvertTitle';
import { fillShortTextInputValue } from './ShortText/shortTextHelpers';
import ShortTextInputField from './ShortText/ShortTextInputField';
import ShortTextHeaderInput from './ShortText/ShortTextHeaderInput';
import ShortTextSubLabelInput from './ShortText/ShortTextSubLabelInput';

// import ShortTextHeaderInput from './ShortTextHeaderInput';
// import ShortTextInputField from './ShortTextInputField';
// import ShortTextSubLabelInput from './ShortTextSubLabelInput';
// import { fillShortTextInputValue } from '../utils/shortTextHelpers';

const ShortText = ({ id, header }) => {
  const { drawerData } = useFormContext();
  const existingComponentIndex = drawerData.findIndex(component => component.id === id);
  const { readOnly } = useReadOnly();
  const { finalSelectValues } = useContext(FinalValuesContext);
  const location = useLocation();
  const currentPage = location.pathname;

  const containerRef = useRef(null);

  const switchHeader = header || drawerData[existingComponentIndex]?.state.shortTextValue || 'یک عنوان وارد کنید';
  const switchSubHeader = drawerData[existingComponentIndex]?.state.subShortTextValue || '';

  const [shortTextValue, setShortTextValue] = useState(switchHeader);
  const [shortTextInputValue, setShortTextInputValue] = useState(drawerData[existingComponentIndex]?.state.mainShortTextInputValue || '');
  const [subShortTextValue, setSubShortTextValue] = useState(switchSubHeader);
  const [isSubHeaderVisible, setSubHeaderVisible] = useState(false);
  const [isHeadingFocused, setHeadingFocused] = useState(false);
  const [charCount, setCharCount] = useState(0);
  const [condition, setCondition] = useState(false);

  const theme = useTheme();
  const isUpXxl = useMediaQuery(theme.breakpoints.up('xxs'));
  const SubHeadingInputFontSize = isUpXxl ? '14px' : '12px';
  const HeadingColor = theme.palette.blue[700];

  let titleIndex = finalSelectValues.findIndex(item => item.name === 'FieldCondition');
  let title = ConvertTitle({ title: finalSelectValues[titleIndex]?.value });
  let isReadOnly = currentPage.startsWith('/publish') || currentPage.startsWith('/card-form/publish') || currentPage.startsWith('/user/fill-form/');

  const handleCondition = () => {
    if (currentPage === '/Publish') {
      setCondition((readOnly || drawerData[existingComponentIndex]?.state.readOnly) && title === 'ShortText');
    } else {
      setCondition(false);
    }
  };

  const handleHeadingFocus = (event) => {
    setHeadingFocused(true);
    event.target.select();
  };

  const handleClickOutside = (event) => {
    if (containerRef.current && !containerRef.current.contains(event.target)) {
      setSubHeaderVisible(false);
      setHeadingFocused(false);
    } else {
      setSubHeaderVisible(true);
      setHeadingFocused(true);
    }
  };

  const handleShortTextChange = (event) => {
    setShortTextValue(event.target.value);
  };

  const handleShortTextInputChange = (event) => {
    const value = event.target.value;
    if (value.length <= 100) {
      setShortTextInputValue(value);
      setCharCount(value.length);
    }
  };

  const handleSubShortTextChange = (event) => {
    setSubShortTextValue(event.target.value);
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  useEffect(() => {
    fillShortTextInputValue({
      drawerData,
      index: existingComponentIndex,
      values: { shortTextValue, shortTextInputValue, subShortTextValue },
      readOnly
    });
  }, [id, shortTextInputValue, shortTextValue, subShortTextValue]);

  useEffect(() => {
    handleCondition();
  }, [finalSelectValues, readOnly]);

  return (
    <Grid
      mb={currentPage.startsWith('/build') || currentPage.startsWith('/publish') ? '28px' : '50px'}
      p={drawerData.length > 0 ? (currentPage.startsWith('/build') || currentPage.startsWith('/publish') || currentPage.startsWith('/user/fill-form') ? '12px 10px' : { xs: '12px', md: '24px' }) : '0px'}
      mx={currentPage === '/build' || currentPage === '/publish' ? '4px' : '0px'}
      borderRadius="3px"
      width="100%"
      bgcolor="white"
      ref={containerRef}
      border={`2px solid ${isHeadingFocused && drawerData.length > 0 && drawerData[existingComponentIndex] && !isReadOnly ? '#0293e2' : 'transparent'}`}
      onClick={handleClickOutside}
    >
      <Grid className="HeadingInput" pb="14px">
        <ShortTextHeaderInput
          value={shortTextValue}
          onChange={handleShortTextChange}
          onClick={handleClickOutside}
          onFocus={isReadOnly ? null : handleHeadingFocus}
          readOnly={isReadOnly || condition}
          color={HeadingColor}
        />
      </Grid>

      <Grid>
        <ShortTextInputField
          value={shortTextInputValue}
          onChange={handleShortTextInputChange}
          charCount={charCount}
          readOnly={condition}
          color={HeadingColor}
        />
      </Grid>

      <Grid display={isReadOnly && subShortTextValue === '' ? 'none' : 'block'}>
        {isSubHeaderVisible && (
          <Grid className="subHeader" pb="14px">
            <ShortTextSubLabelInput
              value={subShortTextValue}
              onChange={handleSubShortTextChange}
              readOnly={isReadOnly || condition}
              fontSize={SubHeadingInputFontSize}
            />
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default ShortText;
